import { render } from "./UploadBox.vue?vue&type=template&id=466a122a&scoped=true"
import script from "./UploadBox.vue?vue&type=script&lang=js"
export * from "./UploadBox.vue?vue&type=script&lang=js"

import "./UploadBox.vue?vue&type=style&index=0&id=466a122a&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466a122a"]])

export default __exports__